import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from '../lib/icons';

export interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
  /** "light" = weiße Schrift auf farbigem Hintergrund (z.B. Hero-Bereich); "dark" = Standard auf hellem Hintergrund */
  variant?: 'light' | 'dark';
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = '', variant = 'dark' }) => {
  if (items.length === 0) return null;

  const isLight = variant === 'light';
  const baseColor = isLight ? 'text-white/70' : 'text-gray-500';
  const linkHover = isLight ? 'hover:text-white' : 'hover:text-blue-600';
  const currentColor = isLight ? 'text-white' : 'text-gray-900';
  const sepColor = isLight ? 'text-white/40' : 'text-gray-400';

  return (
    <nav aria-label="Breadcrumb" className={`text-xs sm:text-sm ${className}`}>
      <ol className={`flex flex-wrap items-center gap-x-1.5 gap-y-1 ${baseColor}`}>
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          const isFirst = idx === 0;
          return (
            <li key={`${item.name}-${idx}`} className="flex items-center gap-1.5">
              {idx > 0 && <ChevronRight className={`w-3 h-3 shrink-0 ${sepColor}`} aria-hidden="true" />}
              {isLast || !item.href ? (
                <span
                  className={`${isLast ? `${currentColor} font-medium` : ''} truncate max-w-[28ch] sm:max-w-[44ch]`}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {isFirst ? (
                    <Home className="w-3.5 h-3.5 inline-block -mt-0.5" aria-label="Startseite" />
                  ) : (
                    item.name
                  )}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className={`${linkHover} transition-colors inline-flex items-center gap-1 truncate max-w-[28ch] sm:max-w-[44ch]`}
                >
                  {isFirst ? (
                    <Home className="w-3.5 h-3.5" aria-label="Startseite" />
                  ) : (
                    item.name
                  )}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
